enum REFRESH_CELLS_CONDITIONS {
  ALWAYS_REFRESH = 'always_refresh',
}

export { REFRESH_CELLS_CONDITIONS };
